<button
  class="button button--quick-action button--quick-action--{{ theme }} flex-grow-1"
  height="108px"
  [disabled]="disabled"
  (click)="paymentClick.emit(type)"
>
  <i class="{{ icon }}"></i>
  {{ type | trans:'payment-button/' + type + '.Label' }}
</button>
